import {ALLOWED_NON_TOKEN_COLORS} from './_constants';

const borderTransformer = (v: string) => `1px solid ${v}`;

export const border = {
  border: {
    scale: 'colors',
    transform: borderTransformer,
  },
  borderWidth: {
    scale: 'space',
  },
  borderStyle: {
    scale: true,
  },
  borderColor: {
    scale: 'colors',
    strictView: true,
    includes: ALLOWED_NON_TOKEN_COLORS,
  },
  borderRadius: {
    scale: 'radii',
  },
  borderTop: {
    scale: 'colors',
    transform: borderTransformer,
  },
  borderTopLeftRadius: {
    scale: 'radii',
  },
  borderTopRightRadius: {
    scale: 'radii',
  },
  borderRight: {
    scale: 'colors',
    transform: borderTransformer,
  },
  borderBottom: {
    scale: 'colors',
    transform: borderTransformer,
  },
  borderBottomLeftRadius: {
    scale: 'radii',
  },
  borderBottomRightRadius: {
    scale: 'radii',
  },
  borderLeft: {
    scale: 'colors',
    transform: borderTransformer,
  },
  borderX: {
    scale: 'colors',
    transform: borderTransformer,
    properties: ['borderLeft', 'borderRight'],
  },
  borderY: {
    scale: 'colors',
    transform: borderTransformer,
    properties: ['borderTop', 'borderBottom'],
  },
  borderTopWidth: {
    scale: 'space',
  },
  borderTopColor: {
    scale: 'colors',
    strictView: true,
    includes: ALLOWED_NON_TOKEN_COLORS,
  },
  borderTopStyle: {
    scale: true,
  },
  borderBottomWidth: {
    scale: 'space',
  },
  borderBottomColor: {
    scale: 'colors',
    strictView: true,
    includes: ALLOWED_NON_TOKEN_COLORS,
  },
  borderBottomStyle: {
    scale: true,
  },
  borderLeftColor: {
    scale: 'colors',
    strictView: true,
    includes: ALLOWED_NON_TOKEN_COLORS,
  },
  borderLeftStyle: {
    scale: true,
  },
  borderLeftWidth: {
    scale: 'space',
  },
  borderRightColor: {
    scale: 'colors',
    strictView: true,
    includes: ALLOWED_NON_TOKEN_COLORS,
  },
  borderRightStyle: {
    scale: true,
  },
  borderRightWidth: {
    scale: 'space',
  },
  borderTopRadius: {
    scale: 'radii',
    properties: ['borderTopLeftRadius', 'borderTopRightRadius'],
  },
  borderBottomRadius: {
    scale: 'radii',
    properties: ['borderBottomLeftRadius', 'borderBottomRightRadius'],
  },
} as const;
/**
 * NextJS 12.2.5 does not support `satisfies` assertion
 * Once we upgrade NextJS, these should be `as const satisfies ScaleObject`
 */

export type Border = typeof border;
